import styled from 'styled-components';
import { Scrollbar } from '@ann/web-components';

export const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;

export const PillButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  height: 40px;
  border-radius: 100px;
  border: 1px solid ${(props) => props.theme.colors.davysGrey};
  background: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.text};
  white-space: nowrap;
  cursor: pointer;
  font: inherit;
  box-sizing: border-box;

  &:hover {
    background: ${(props) => props.theme.colors.ghostWhite};
  }
`;

export const Panel = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 20;
  width: 475px;
  background: ${(props) => props.theme.colors.white};
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.08);
  border: 1px solid ${(props) => props.theme.colors.ghostWhite};
  overflow: hidden;
`;

export const PanelScrollbar = styled(Scrollbar).attrs({
  size: 'small',
  autoHide: 'false',
  display: 'flex',
  padding: '0',
})`
  flex-direction: column;
  align-items: stretch;
  max-height: 300px;
  overscroll-behavior: contain;
`;

export const PanelContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-width: 0;
  min-height: min-content;
  padding: 8px 0;
`;

export const SectionHeader = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;

  &:hover {
    background: ${(props) => props.theme.colors.ghostWhite};
  }

  &:disabled {
    cursor: default;
    opacity: 1;
  }
`;

export const SectionHeaderLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.48px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.text};
`;

export const ChevronWrap = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  color: ${(props) => props.theme.colors.neutral};
`;

export const CheckboxRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 8px 16px 8px 24px;
  cursor: pointer;
  margin: 0;

  &:hover {
    background: ${(props) => props.theme.colors.ghostWhite};
  }
`;

export const CheckboxLabel = styled.span`
  flex: 1;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.colors.text};
`;

